var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-y-10 md:gap-y-10 mb-10 md:mb-10"},_vm._l((_vm.rows),function(row,i){return _c('MoleculeModalRowButton',{key:i,attrs:{"item":row}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }